<div class="relative">
    <div class="flex items-center mb-1">
        <mat-icon svgIcon="heroicons_outline:x-circle" 
                  matTooltip="Cerrar" 
                  mat-dialog-close
                  class="absolute top-2 right-2 cursor-pointer z-50">
        </mat-icon>
    </div>

    <h2 mat-dialog-title class="text-lg font-bold mb-1">
        <span *ngIf="data.materialCode && data.materialName" class="text-gray-600">
            Detalle de lotes - {{ data.materialCode }} - {{ data.materialName }}
        </span>
    </h2>

    <app-manual-label-selection-indicator
        class="mb-2 flex items-center"
        [manuallySelected]="data.manuallySelected === true"
        [showText]="true" />

    <mat-dialog-content class="max-h-[70vh] overflow-y-auto">
        <!-- Summary Information -->
        <div class="flex flex-wrap gap-x-8 gap-y-2 p-2 border border-gray-200 rounded bg-gray-50 mb-4 text-sm text-black">
            <p *ngIf="data.documentSerial" class="font-medium">
                <strong>Nro Doc:</strong> {{ data.documentSerial }}
            </p>
            <p *ngIf="data.baseQuantity" class="font-medium">
                <strong>Cantidad UMB:</strong> {{ data.baseQuantity | number: '1.3' }}
            </p>
            <p *ngIf="data.parallelQuantity" class="font-medium">
                <strong>Cantidad UMP:</strong> {{ data.parallelQuantity | number: '1.3' }}
            </p>
        </div>

        <!-- Batches Table -->
        <div class="w-full">
            <table mat-table 
                   [dataSource]="dataSourceBatches"
                   multiTemplateDataRows
                   class="w-full min-w-[500px] border border-gray-200">
                
                <!-- Expand Column -->
                <ng-container matColumnDef="expand">
                    <th mat-header-cell *matHeaderCellDef class="w-12"></th>
                    <td mat-cell *matCellDef="let batch" class="w-12">
                        <ng-container *ngIf="batch?.labels && batch?.labels?.length > 0">
                            <button mat-icon-button 
                                    (click)="toggleExpand(batch)"
                                    class="text-gray-600 hover:text-gray-800">
                                <mat-icon>{{batch.expanded ? 'expand_less' : 'expand_more'}}</mat-icon>
                            </button>
                        </ng-container>
                    </td>
                </ng-container>

                <!-- Batch Column -->
                <ng-container matColumnDef="batch">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left font-semibold">Lote</th>
                    <td mat-cell *matCellDef="let batch" class="px-6 text-left">
                        {{ batch?.bacth }}
                    </td>
                </ng-container>

                <!-- UMB Quantity Column -->
                <ng-container matColumnDef="umb">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left font-semibold">Cantidad UMB</th>
                    <td mat-cell *matCellDef="let batch" class="px-6 text-left">
                        {{ batch?.quantity | number: '1.3' }}
                    </td>
                </ng-container>

                <!-- UMP Quantity Column (conditional) -->
                <ng-container matColumnDef="ump">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left font-semibold">Cantidad UMP</th>
                    <td mat-cell *matCellDef="let batch" class="px-6 text-left">
                        {{ batch?.parallelQuantity | number: '1.3' }}
                    </td>
                </ng-container>

                <!-- Nested Labels Table -->
                <ng-container matColumnDef="nestedTable">
                    <td mat-cell *matCellDef="let batch" [attr.colspan]="displayedColumnsBatches.length">
                        <div *ngIf="batch?.labels && batch?.labels?.length > 0 && data.showLabels" 
                             class="overflow-hidden p-2 bg-gray-50"
                             [@detailExpand]="batch.expanded ? 'expanded' : 'collapsed'">
                            <table mat-table
                                   [dataSource]="batch.labels" 
                                   class="w-full border border-gray-300 rounded">
                                
                                <!-- Label Batch Column -->
                                <ng-container matColumnDef="batch">
                                    <th mat-header-cell *matHeaderCellDef class="text-left font-semibold bg-gray-100">Etiqueta</th>
                                    <td mat-cell *matCellDef="let label" class="text-left px-4 py-2">
                                        {{ label?.label }}
                                    </td>
                                </ng-container>

                                <!-- Label UMB Column -->
                                <ng-container matColumnDef="umb">
                                    <th mat-header-cell *matHeaderCellDef class="text-left font-semibold bg-gray-100">Cantidad UMB</th>
                                    <td mat-cell *matCellDef="let label" class="text-left px-4 py-2">
                                        {{ label?.quantity | number: '1.3' }}
                                    </td>
                                </ng-container>

                                <!-- Label UMP Column (conditional) -->
                                <ng-container matColumnDef="ump">
                                    <th mat-header-cell *matHeaderCellDef class="text-left font-semibold bg-gray-100">Cantidad UMP</th>
                                    <td mat-cell *matCellDef="let label" class="text-left px-4 py-2">
                                        {{ label?.parallelQuantity | number: '1.3' }}
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumnsDetail" class="bg-gray-100"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumnsDetail; let i = index"
                                    [trackBy]="trackByLabelFn" 
                                    class="hover:bg-gray-50"></tr>
                            </table>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsBatches" class="bg-gray-100"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsBatches; let i = index"
                    [trackBy]="trackBy" 
                    class="border-b hover:bg-gray-50"></tr>
                <tr mat-row *matRowDef="let row; columns: ['nestedTable']; when: hasNestedContent"
                    class="bg-gray-50"></tr>
            </table>
            
            <!-- Empty State -->
            <ng-container *ngIf="dataSourceBatches.data && dataSourceBatches.data.length === 0">
                <div class="flex justify-center items-center h-32 bg-gray-50 rounded border">
                    <p class="text-gray-500 text-sm">No hay lotes disponibles</p>
                </div>
            </ng-container>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions class="flex justify-end p-4 border-t border-gray-200">
        <button mat-button 
                (click)="onClose()"
                class="px-4 py-2 text-gray-600 hover:text-gray-800">
            Cerrar
        </button>
    </mat-dialog-actions>
</div>
